<template>
  <div class="pdfPrint">
    <div class="jump-btn">
      <el-button type="primary" @click="print">打印pdf</el-button>
      <el-button type="primary" @click="jump()">返回</el-button>
    </div>
    <div id="print">
      <h2><span v-if="formData.mai_REP_TYPE==1">半月</span><span v-if="formData.mai_REP_TYPE==2">季度</span><span
          v-if="formData.mai_REP_TYPE==3">半年</span><span v-if="formData.mai_REP_TYPE==4">年度</span>维保记录（自动扶梯/曳引与强制驱动电梯）</h2>
      <table border="1" width="900">
        <tr>
          <td width="10%" colspan="1">保养<br>单号</td>
          <td width="20%" colspan="2">{{formData.mai_REPORT}}</td>
          <td width="10%" colspan="1">维保<br>单位</td>
          <td width="20%" colspan="2">{{formData.mai_UNIT_NAME}}</td>
          <td width="10%" colspan="1">使用<br>单位</td>
          <td width="30%" colspan="3">{{formData.use_UNIT_NAME}}</td>
        </tr>
        <tr>
          <td width="10%" colspan="1">设备<br>代码</td>
          <td width="90%" colspan="10">
            <span class="tac">{{formData.mai_DEV_CODE}}</span>
          </td>
        </tr>
        <tr>
          <td width="10%" colspan="1">维保情况<br>符号</td>
          <td width="10%" colspan="10">
            <span
              class="tac">检查正常:√&nbsp;&nbsp;&nbsp;&nbsp;异常现象已修复:O&nbsp;&nbsp;&nbsp;&nbsp;异常现象待修复:X&nbsp;&nbsp;&nbsp;&nbsp;无此项:/</span>
          </td>
        </tr>
      </table>
      <!-- <div class="listBox">
      <div class="box">
        <div class="flex">
          <span class="w50">序号</span>
          <span class="w150">维保项目(内容)</span>
          <span class="w70">维保情况</span>
        </div>
        <div class="flex">
          <span class="w50">序号</span>
          <span class="w150">维保项目(内容)</span>
          <span class="w70">维保情况</span>
        </div>
        <div class="flex">
          <span class="w50">序号</span>
          <span class="w150">维保项目(内容)</span>
          <span class="w70">维保情况</span>
        </div>
      </div>
      <div class="box1">
        <div v-for="(item, index) in tableData" :key="index">
          <span class="w50">{{index+1}}</span>
          <span class="w150">{{item.text}}</span>
          <span class="w70">√</span>
        </div>
      </div>
    </div> -->
      <table border="1" width="900">
        <tr>
          <th>序号</th>
          <th>维保项目(内容)</th>
          <th>维保情况</th>
        </tr>
        <tr v-for="(item, index) in formData.content" :key="index">
          <td>{{index+1}}</td>
          <td v-if="item.state!=3">{{item.field_NAME}}</td>
          <td v-else>{{item.field_NAME}}（无此项）</td>
          <td v-if="item.state==2">O</td>
          <td v-else-if="item.state==3">/</td>
          <td v-else>√</td>
        </tr>
      </table>
      <table border="1" width="900">
        <tr>
          <td rowspan="4" colspan="1" width="10%">备<br>注</td>
          <td rowspan="4" colspan="10" width="90%"></td>
        </tr>
      </table>
      <table border="1" width="900">
        <tr>
          <td rowspan="4">维<br>保<br>账<br>号</td>
          <td>姓名</td>
          <td>操作证号</td>
          <td rowspan="4">维<br>保<br>人<br>员<br>签<br>字</td>
          <td rowspan="4">
            <img width="80" :src="formData.mai_MAN_SIGN">
          </td>
          <td rowspan="4">使<br>用<br>单<br>位<br>签<br>字</td>
          <td rowspan="4">
            <img width="80" :src="formData.use_UNIT_SIGN">
          </td>
        </tr>
        <tr>
          <td>{{formData.mai_MAN}}</td>
          <td>{{formData.man_OPERATION_NUM}}</td>
        </tr>
        <tr>
          <!-- <td></td>
          <td></td> -->
        </tr>
        <tr>
          <!-- <td></td>
          <td></td> -->
        </tr>
        <tr>
          <td colspan="3">{{time}}</td>
          <td colspan="2">{{formData.mai_MAN_SIGN_TIME.substring(0, 10)}}</td>
          <td colspan="2">{{formData.use_UNIT_SIGN_TIME.substring(0, 10)}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:pdfPrint
   *@Description:pdf打印
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2023-06-12
   */
  import printHtml from '../../config/print.js'
  export default {
    data() {
      return {
        id: '',
        formData: {},
        time: ''
      }
    },
    created() {
      this.id = this.$route.query.id
      // this.id = 259257
      this.getLiftPdf()
      this.time = this.format(Date.parse(new Date()))
    },
    watch: {

    },
    methods: {
      // 返回
      jump() {
        this.$router.back()
        // this.$router.go(-1)
      },
      // 获取pdf数据
      getLiftPdf() {
        let loading = this.$loading()
        this.$get(`aapi/maintains/${this.id}/liftPdf`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.list)
              this.formData = res.list[0]
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      print() {
        // window.print()
        setTimeout(() => {
          // 取自己页面需要打印内容的标签
          let printDocument = document.getElementById('print')
          // 取出需要打印的内容
          let printData = printDocument.innerHTML
          // 调用打印方法
          printHtml(printData)
        }, 300)
      },
      format(dataString) {
        let time = new Date(dataString)
        let year = time.getFullYear()
        let month = time.getMonth() + 1
        let day = time.getDate()
        return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
        // let hour = time.getHours()
        // let minute = time.getMinutes()
        // let second = time.getSeconds()
        // return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hour < 10 ?
        //   '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second :
        //   second)
      }
    }

  }
</script>

<style lang="scss">
  .pdfPrint {
    // .listBox {
    //   width: 810px;
    //   margin: 0 auto;
    // }

    // .box {
    //   display: flex;
    //   width: 100%;
    // }

    // .flex {
    //   flex: 1;
    //   text-align: center;
    //   word-spacing: -100px;
    // }

    // .w50 {
    //   width: 50px;
    // }

    // .w70 {
    //   width: 70px;
    // }

    // .w150 {
    //   width: 150px;
    // }

    // .listBox span {
    //   display: inline-block;
    //   border: 1px solid #808080;
    //   padding: 5px 0;
    //   box-sizing: border-box;
    // }

    // .box1 {
    //   display: flex;
    //   width: 100%;
    //   flex-wrap: wrap;
    //   word-spacing: -100px;
    //   text-align: center;
    // }

    // table,
    // th,
    // td {
    //   border: 1px solid black;
    //   border-collapse: collapse;
    //   padding: 5px 10px;
    //   font-weight: normal;
    // }
    .mr10 {
      margin-right: 10px;
    }

    .tac {
      text-align: center;
    }

    .tar {
      text-align: right;
    }

    h2 {
      margin: 0 auto 20px;
      text-align: center;
      // width: 630px;
    }

    table {
      border-collapse: collapse;
      text-align: center;
      margin: 0 auto;
    }

    table span {
      display: inline-block;
      // width: 180px;
    }

    table tr td {
      // height: 50px;
    }

    #time span {
      width: 30px;
    }
  }
</style>